import React from 'react';
import { IconSvgProps } from '@models/common';

const AILogoGradient: React.FC<IconSvgProps> = (props) => {
  const { size = 30, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'>
      <path
        fill='url(#a)'
        d='M21.3 13.99c.374.886 1.63.886 2.005 0l1.248-2.954c.11-.261.318-.469.579-.58l2.953-1.247c.887-.374.887-1.631 0-2.006l-2.953-1.247a1.089 1.089 0 0 1-.58-.58l-1.247-2.953c-.374-.886-1.63-.886-2.006 0l-1.247 2.954c-.11.26-.318.469-.58.579L16.52 7.203c-.886.375-.886 1.632 0 2.006l2.954 1.248c.26.11.469.318.579.579l1.247 2.953Z'
      />
      <path
        fill='url(#b)'
        d='M20.555 27.791a.726.726 0 0 0 1.337 0l.678-1.604a.726.726 0 0 1 .386-.386l1.605-.678a.726.726 0 0 0 0-1.337l-1.605-.678a.726.726 0 0 1-.386-.386l-.678-1.605a.726.726 0 0 0-1.337 0l-.677 1.605a.726.726 0 0 1-.387.386l-1.604.678a.726.726 0 0 0 0 1.337l1.604.678a.726.726 0 0 1 .387.386l.677 1.604Z'
      />
      <path
        fill='url(#c)'
        d='M10.176 26.01c.375.886 1.631.886 2.006 0l2.281-5.401c.11-.261.319-.47.58-.58l5.4-2.28c.887-.375.887-1.632 0-2.006l-5.4-2.282a1.089 1.089 0 0 1-.58-.58l-2.281-5.4c-.375-.886-1.631-.886-2.006 0l-2.281 5.4c-.11.262-.318.47-.58.58l-5.4 2.281c-.887.375-.887 1.631 0 2.006l5.4 2.282c.262.11.47.318.58.579l2.281 5.4Z'
      />
      <defs>
        <linearGradient
          id='a'
          x1='15.855'
          x2='28.75'
          y1='14.654'
          y2='1.759'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F2C72F' />
          <stop
            offset='.552'
            stopColor='#FB9E14'
          />
          <stop
            offset='1'
            stopColor='#E4680D'
          />
        </linearGradient>
        <linearGradient
          id='b'
          x1='17.443'
          x2='25.005'
          y1='28.235'
          y2='20.674'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F2C72F' />
          <stop
            offset='.552'
            stopColor='#FB9E14'
          />
          <stop
            offset='1'
            stopColor='#E4680D'
          />
        </linearGradient>
        <linearGradient
          id='c'
          x1='1.25'
          x2='21.108'
          y1='26.674'
          y2='6.816'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F2C72F' />
          <stop
            offset='.552'
            stopColor='#FB9E14'
          />
          <stop
            offset='1'
            stopColor='#E4680D'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AILogoGradient;
